module.exports = __webpack_public_path__ + "static/img/SO.f328ec72.png";